import {
  Col,
  message,
  PageHeader,
  Row,
  Spin,
  Select,
  Space,
  Tabs,
} from "antd";
import axios from "axios";
import React, { Component } from "react";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { connect } from "react-redux";
import {
  SelectItem,
  Form,
  FormItem,
  cuentaMask,
  TableItem,
  dineroDisabledMask,
  RangePickerItem,
  ButtonItem,
  ErrorItem,
  SelectCuentaContableItem,
} from "../../../../Components/Items";
import { FileExcelOutlined } from "@ant-design/icons";
import AccionesPolizaReporte from "../../../../Components/AccionesPolizaReporte";
import ModalPdfPoliza from "../../../../Components/ModalPdfPoliza";
import ModalEditarPoliza from "../../../../Components/ModalEditarPoliza";
import * as XLSXStyle from "xlsx-js-style";
import moment from "moment";
import "moment/locale/es";

moment.locale("es");
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Option } = Select;
const { TabPane } = Tabs;

class ReporteLibroMayor extends Component {
  state = {
    loading: false,
    dataReporte: null,
    todasFilas: [],
    objetoProyectos: null,
    todasProyectos: null,
    objetoUniadesDeNegocio: null,
    todasUniadesDeNegocio: null,
    ultimosFiltros: null,
    modalPdfPoliza: false,
    polizaIdPdf: null,
    modalEditarPoliza: false,
    polizaIdEditar: null,
  };

  atras() {
    this.props.history.goBack();
  }

  abrirVerPoliza = (polizaId) => {
    this.setState({ modalPdfPoliza: true, polizaIdPdf: polizaId });
  };
  cerrarVerPoliza = () => {
    this.setState({ modalPdfPoliza: false, polizaIdPdf: null });
  };
  abrirEditarPoliza = (polizaId) => {
    this.setState({ modalEditarPoliza: true, polizaIdEditar: polizaId });
  };
  cerrarEditarPoliza = () => {
    this.setState({ modalEditarPoliza: false, polizaIdEditar: null });
  };
  // Se vuelve a consultar con los mismos filtros para que el reporte refleje el cambio.
  polizaEditada = () => {
    if (this.state.ultimosFiltros) {
      this.consultarReporte(this.state.ultimosFiltros);
    }
  };

  async componentDidMount() {
    this.setState({ loading: true });
    await axios
      .post(
        "proyectos/selectProyectos",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({ todasProyectos: res.data });
          this.setState({
            objetoProyectos: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {value.nombre}
              </Option>
            )),
          });
        }
      });
    await axios
      .post(
        "unidadesdenegocio/selectUnidadesDeNegocio",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({ todasUniadesDeNegocio: res.data });
          this.setState({
            objetoUniadesDeNegocio: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {cuentaMask(
                  value.nivel1 +
                    value.nivel2 +
                    value.nivel3 +
                    value.nivel4 +
                    value.nivel5
                ) +
                  " - " +
                  value.nombre}
              </Option>
            )),
          });
        }
      });
    this.consultarReporte({
      periodo: [moment().subtract(1, "month"), moment()],
    });
  }

  consultarReporte(values) {
    this.setState({ loading: true, ultimosFiltros: values });
    axios
      .post(
        "reportesFinancieros/reporteLibroMayor",
        { ...values, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          let todasFilas = [];
          for (const cuenta of res.data.cuentas) {
            const cuentaStr = cuentaMask(
              cuenta.cuentaContable.nivel1 +
                cuenta.cuentaContable.nivel2 +
                cuenta.cuentaContable.nivel3 +
                cuenta.cuentaContable.nivel4 +
                cuenta.cuentaContable.nivel5
            );
            todasFilas.push({
              key: `h_${cuenta.cuentaContable._id}`,
              isHeader: true,
              fecha: cuentaStr + " — " + cuenta.cuentaContable.descripcion,
            });
            todasFilas.push({
              key: `si_${cuenta.cuentaContable._id}`,
              isSaldoInicial: true,
              fecha: "SALDO INICIAL",
              saldo: cuenta.saldoInicial,
            });
            for (const mov of cuenta.movimientos) {
              todasFilas.push({
                key: `m_${mov._id}`,
                fecha: moment(mov.fecha).format("DD/MM/YYYY"),
                concepto:
                  mov.concepto +
                  " : " +
                  mov.numeroTipoPoliza +
                  " - " +
                  mov.numeroTipoTipoPoliza,
                cargo: mov.cargo ? mov.monto : "-",
                abono: !mov.cargo ? mov.monto : "-",
                saldo: "",
                polizaId: mov.polizaId,
                polizaManual: mov.polizaManual,
                polizaEstado: mov.polizaEstado,
              });
            }
            todasFilas.push({
              key: `t_${cuenta.cuentaContable._id}`,
              isTotal: true,
              fecha: "TOTALES",
              cargo: cuenta.totalCargo,
              abono: cuenta.totalAbono,
              saldo: cuenta.saldoFinal,
            });
          }
          this.setState({ loading: false, dataReporte: res.data, todasFilas });
        } else {
          message.error("Ha sucedido un error y no se cargó bien el reporte");
          this.setState({ loading: false });
        }
      });
  }

  descargarExcel() {
    const HEADER_COLOR = "00BFD6";
    const TOTAL_COLOR = "E6F7FF";
    const ALT_COLOR = "F5FBFC";

    const border = {
      top: { style: "thin", color: { auto: 1 } },
      bottom: { style: "thin", color: { auto: 1 } },
      left: { style: "thin", color: { auto: 1 } },
      right: { style: "thin", color: { auto: 1 } },
    };

    const headerStyle = {
      font: { bold: true, color: { rgb: "FFFFFF" }, sz: 11 },
      fill: { fgColor: { rgb: HEADER_COLOR } },
      alignment: { horizontal: "center", vertical: "center" },
      border,
    };

    const cuentaStyle = {
      font: { bold: true, color: { rgb: "FFFFFF" }, sz: 13 },
      fill: { fgColor: { rgb: "007A8A" } },
      alignment: { horizontal: "left", vertical: "center" },
      border,
    };

    const totalLabelStyle = {
      font: { bold: true, sz: 10 },
      fill: { fgColor: { rgb: TOTAL_COLOR } },
      alignment: { horizontal: "left" },
      border,
    };

    const totalNumStyle = {
      font: { bold: true, sz: 10 },
      fill: { fgColor: { rgb: TOTAL_COLOR } },
      alignment: { horizontal: "right" },
      numFmt: '"$"#,##0.00',
      border,
    };

    const cellStyle = (isAlt) => ({
      font: { sz: 10 },
      fill: { fgColor: { rgb: isAlt ? ALT_COLOR : "FFFFFF" } },
      alignment: { horizontal: "left", wrapText: false },
      border,
    });

    const numCellStyle = (isAlt) => ({
      font: { sz: 10 },
      fill: { fgColor: { rgb: isAlt ? ALT_COLOR : "FFFFFF" } },
      alignment: { horizontal: "right" },
      numFmt: '"$"#,##0.00',
      border,
    });

    const COLS = ["Cuenta", "Descripción", "Fecha", "Concepto", "No. Póliza", "No. Tipo Póliza", "Cargo", "Abono", "Saldo"];
    const NUM_COLS = COLS.length - 1;

    const saldoInicialStyle = {
      font: { bold: true, sz: 10, color: { rgb: "005F6B" } },
      fill: { fgColor: { rgb: "D6F4F8" } },
      alignment: { horizontal: "left" },
      border,
    };

    const saldoInicialNumStyle = {
      font: { bold: true, sz: 10, color: { rgb: "005F6B" } },
      fill: { fgColor: { rgb: "D6F4F8" } },
      alignment: { horizontal: "right" },
      numFmt: '"$"#,##0.00',
      border,
    };

    const rows = [
      COLS.map((h) => ({ v: h, t: "s", s: headerStyle })),
    ];
    const merges = [];

    for (const cuenta of this.state.dataReporte.cuentas) {
      const cuentaStr = cuentaMask(
        cuenta.cuentaContable.nivel1 +
          cuenta.cuentaContable.nivel2 +
          cuenta.cuentaContable.nivel3 +
          cuenta.cuentaContable.nivel4 +
          cuenta.cuentaContable.nivel5
      );
      const cuentaLabel = `${cuentaStr} — ${cuenta.cuentaContable.descripcion}`;

      const cuentaRowIdx = rows.length;
      merges.push({ s: { r: cuentaRowIdx, c: 0 }, e: { r: cuentaRowIdx, c: NUM_COLS } });
      rows.push([
        { v: cuentaLabel, t: "s", s: cuentaStyle },
        ...Array(NUM_COLS).fill({ v: "", t: "s", s: cuentaStyle }),
      ]);

      const siRowIdx = rows.length;
      merges.push({ s: { r: siRowIdx, c: 0 }, e: { r: siRowIdx, c: NUM_COLS - 1 } });
      rows.push([
        { v: "SALDO INICIAL", t: "s", s: saldoInicialStyle },
        ...Array(NUM_COLS - 1).fill({ v: "", t: "s", s: saldoInicialStyle }),
        { v: cuenta.saldoInicial, t: "n", s: saldoInicialNumStyle },
      ]);

      cuenta.movimientos.forEach((mov, idx) => {
        const alt = idx % 2 === 1;
        rows.push([
          { v: cuentaStr, t: "s", s: cellStyle(alt) },
          { v: cuenta.cuentaContable.descripcion, t: "s", s: cellStyle(alt) },
          { v: moment(mov.fecha).format("DD/MM/YYYY"), t: "s", s: cellStyle(alt) },
          { v: mov.concepto, t: "s", s: cellStyle(alt) },
          { v: mov.numeroTipoPoliza, t: "s", s: cellStyle(alt) },
          { v: mov.numeroTipoTipoPoliza, t: "s", s: cellStyle(alt) },
          { v: mov.cargo ? mov.monto : 0, t: "n", s: numCellStyle(alt) },
          { v: !mov.cargo ? mov.monto : 0, t: "n", s: numCellStyle(alt) },
          { v: "", t: "s", s: cellStyle(alt) },
        ]);
      });

      const totRowIdx = rows.length;
      merges.push({ s: { r: totRowIdx, c: 0 }, e: { r: totRowIdx, c: NUM_COLS - 3 } });
      rows.push([
        { v: "TOTALES", t: "s", s: totalLabelStyle },
        ...Array(NUM_COLS - 3).fill({ v: "", t: "s", s: totalLabelStyle }),
        { v: cuenta.totalCargo, t: "n", s: totalNumStyle },
        { v: cuenta.totalAbono, t: "n", s: totalNumStyle },
        { v: cuenta.saldoFinal, t: "n", s: totalNumStyle },
      ]);
    }

    const worksheet = XLSXStyle.utils.aoa_to_sheet(rows);
    worksheet["!merges"] = merges;
    worksheet["!cols"] = [
      { wch: 14 }, { wch: 28 }, { wch: 12 }, { wch: 36 },
      { wch: 12 }, { wch: 16 }, { wch: 14 }, { wch: 14 }, { wch: 14 },
    ];

    const workbook = XLSXStyle.utils.book_new();
    XLSXStyle.utils.book_append_sheet(workbook, worksheet, "Libro Mayor");
    XLSXStyle.writeFile(workbook, `Libro_Mayor_${moment().format("DD-MM-YYYY")}.xlsx`);
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  render() {
    const columns = [
      {
        title: "Fecha",
        dataIndex: "fecha",
        key: "fecha",
        width: "15%",
        // Los colSpan de cada tipo de renglon deben sumar el numero de columnas (6)
        onCell: (record) => ({
          colSpan: record.isHeader ? 6 : record.isTotal ? 2 : record.isSaldoInicial ? 4 : 1,
          style: record.isHeader ? { paddingLeft: 10 } : {},
        }),
      },
      {
        title: "Concepto",
        dataIndex: "concepto",
        key: "concepto",
        width: "35%",
        ellipsis: true,
        onCell: (record) => ({
          colSpan: record.isHeader || record.isTotal || record.isSaldoInicial ? 0 : 1,
        }),
      },
      {
        title: "Cargo",
        dataIndex: "cargo",
        key: "cargo",
        width: "14%",
        align: "right",
        render: (value) =>
          value === "" || value === undefined
            ? ""
            : isNaN(value)
            ? value
            : dineroDisabledMask(value),
        onCell: (record) => ({
          colSpan: record.isHeader || record.isSaldoInicial ? 0 : 1,
        }),
      },
      {
        title: "Abono",
        dataIndex: "abono",
        key: "abono",
        width: "14%",
        align: "right",
        render: (value) =>
          value === "" || value === undefined
            ? ""
            : isNaN(value)
            ? value
            : dineroDisabledMask(value),
        onCell: (record) => ({
          colSpan: record.isHeader || record.isSaldoInicial ? 0 : 1,
        }),
      },
      {
        title: "Saldo",
        dataIndex: "saldo",
        key: "saldo",
        width: "14%",
        align: "right",
        render: (value) =>
          value === "" || value === undefined
            ? ""
            : dineroDisabledMask(value),
        onCell: (record) => ({
          colSpan: record.isHeader ? 0 : 1,
        }),
      },
      {
        title: "Acción",
        dataIndex: "accion",
        key: "accion",
        width: "8%",
        align: "center",
        onCell: (record) => ({
          colSpan: record.isHeader ? 0 : 1,
        }),
        render: (value, record) => (
          <AccionesPolizaReporte
            polizaId={record.polizaId}
            polizaManual={record.polizaManual}
            polizaEstado={record.polizaEstado}
            permisoEditarPolizas={this.props.permisoEditarPolizas}
            editarTodasLasPolizas={this.props.editarTodasLasPolizas}
            onVer={this.abrirVerPoliza}
            onEditar={this.abrirEditarPoliza}
          />
        ),
      },
    ];

    return (
      <>
        <Form
          ref={this.formRef}
          name="reporteLibroMayor"
          onFinish={this.consultarReporte.bind(this)}
          onFinishFailed={this.onFinishFailed}
        >
          <PageHeader
            onBack={this.atras.bind(this)}
            title="Reporte Libro Mayor"
            style={{
              border: "1px solid rgb(235, 237, 240)",
              backgroundColor: "white",
              marginBottom: 10,
            }}
            extra={
              <div style={{ display: "flex", justifyContent: "right" }}>
                <Space>
                  {this.state.dataReporte && (
                    <ButtonItem
                      blanco
                      onClick={() => this.descargarExcel()}
                      icon={<FileExcelOutlined />}
                      style={{ display: "block", margin: "0 0 0 auto" }}
                    >
                      Descargar Excel
                    </ButtonItem>
                  )}
                  <ButtonItem
                    type="primary"
                    htmlType="submit"
                    style={{ display: "block", margin: "0 0 0 auto" }}
                  >
                    Consultar
                  </ButtonItem>
                </Space>
              </div>
            }
          />
          <Spin spinning={this.state.loading}>
            <div
              style={{
                backgroundColor: "white",
                padding: 20,
                paddingTop: 5,
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
              <Tabs
                style={{ margin: 0 }}
                tabBarExtraContent={{
                  left: (
                    <h1 style={{ padding: 0, margin: "0 10px 0 0" }}>
                      Filtros:
                    </h1>
                  ),
                }}
              >
                <TabPane tabKey="3" key="3" forceRender tab="Periodo">
                  <FormItem
                    initialValue={[moment().subtract(1, "month"), moment()]}
                    name="periodo"
                    required
                    noStyle
                  >
                    <RangePickerItem />
                  </FormItem>
                </TabPane>
                <TabPane tabKey="4" key="4" forceRender tab="Proyecto">
                  <Row>
                    <Col span={8}>
                      <FormItem
                        name="filtrarProyecto"
                        required
                        noStyle
                        initialValue={0}
                      >
                        <SelectItem
                          width="90%"
                          placeholder="Filtrar Proyecto"
                        >
                          <Option default value={0}>
                            Ninguno
                          </Option>
                          <Option value={1}>Proyectos</Option>
                          <Option value={2}>Unidades de negocio</Option>
                        </SelectItem>
                      </FormItem>
                    </Col>
                    <Col span={8}>
                      <FormItem shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                          const filtrarProyecto =
                            getFieldValue("filtrarProyecto");
                          if (filtrarProyecto === 1) {
                            return (
                              <FormItem required name="proyectos" noStyle>
                                <SelectItem
                                  width="90%"
                                  placeholder="Proyectos"
                                  mode="multiple"
                                >
                                  {this.state.objetoProyectos}
                                </SelectItem>
                              </FormItem>
                            );
                          }
                          if (filtrarProyecto === 2) {
                            return (
                              <FormItem
                                required
                                name="unidadDeNegocioId"
                                noStyle
                              >
                                <SelectItem
                                  width="90%"
                                  placeholder="Unidades de Negocio"
                                >
                                  {this.state.objetoUniadesDeNegocio}
                                </SelectItem>
                              </FormItem>
                            );
                          }
                        }}
                      </FormItem>
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tabKey="5" key="5" forceRender tab="Rango de Cuentas">
                  <Row>
                    <Col span={12}>
                      <FormItem name="cuentaIdDesde" noStyle>
                        <SelectCuentaContableItem
                          width="90%"
                          placeholder="Cuenta Desde"
                          allowClear
                          empresaId={this.props.empresaId}
                          headersToken={this.props.headersToken}
                        />
                      </FormItem>
                    </Col>
                    <Col span={12}>
                      <FormItem name="cuentaIdHasta" noStyle>
                        <SelectCuentaContableItem
                          width="90%"
                          placeholder="Cuenta Hasta"
                          allowClear
                          empresaId={this.props.empresaId}
                          headersToken={this.props.headersToken}
                        />
                      </FormItem>
                    </Col>
                  </Row>
                </TabPane>
              </Tabs>
            </div>
            <h1 style={{ textAlign: "center" }}>Movimientos por Cuenta</h1>
            <TableItem
              columns={columns}
              dataSource={this.state.todasFilas}
              size="small"
              pagination={false}
              rowKey={(value) => value.key}
              onRow={(record) => ({
                onDoubleClick: () => {
                  if (record.polizaId) this.abrirVerPoliza(record.polizaId);
                },
              })}
              rowClassName={(record) =>
                record.isHeader
                  ? "libro-mayor-header-row"
                  : record.isSaldoInicial
                  ? "libro-mayor-saldo-inicial-row"
                  : record.isTotal
                  ? "libro-mayor-total-row"
                  : ""
              }
            />
          </Spin>
        </Form>
        <ModalPdfPoliza
          visible={this.state.modalPdfPoliza}
          polizaId={this.state.polizaIdPdf}
          onCancel={this.cerrarVerPoliza}
        />
        <ModalEditarPoliza
          visible={this.state.modalEditarPoliza}
          polizaId={this.state.polizaIdEditar}
          onCancel={this.cerrarEditarPoliza}
          onGuardado={this.polizaEditada}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    permisoEditarPolizas: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "615cea8ff30e81b54183cfbf")?.activado,
    editarTodasLasPolizas: state.empresa.editarTodasLasPolizas,
  };
};

export default connect(mapStateToProps)(ReporteLibroMayor);
